export default __webpack_public_path__ + "static/media/payment_failed.8ca9d0dd.svg";